var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardReplace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7145_63278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 12.4993C18.3346 15.7243 15.7263 18.3327 12.5013 18.3327L13.3763 16.8743M1.66797 7.49935C1.66797 4.27435 4.2763 1.66602 7.5013 1.66602L6.6263 3.12435",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 14.2171H10.0013M3.51797 11.25H8.1513C9.63463 11.25 10.0013 11.6167 10.0013 13.0833V16.5083C10.0013 17.975 9.63463 18.3417 8.1513 18.3417H3.51797C2.03464 18.3417 1.66797 17.975 1.66797 16.5083V13.0833C1.66797 11.6167 2.03464 11.25 3.51797 11.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.63314H18.3333M11.85 1.66602H16.4833C17.9667 1.66602 18.3333 2.03268 18.3333 3.49935V6.92435C18.3333 8.39102 17.9667 8.75768 16.4833 8.75768H11.85C10.3667 8.75768 10 8.39102 10 6.92435V3.49935C10 2.03268 10.3667 1.66602 11.85 1.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7145_63278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardReplace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-replace.678bdd3659533ab225a0f54cc7e8b987.svg";